module.exports = __webpack_public_path__ + "static/media/13.a5acd25f.jpg";